import { combineReducers } from 'redux';
import benchmarkStandings, {
  State as BenchmarkStandingsState,
} from './BenchmarkStandings';
import biggestChanges, { State as BiggestChangesState } from './BiggestChanges';
import contributionVolume, {
  State as ContributionVolumeState,
} from './ContributionVolume';
import highlights, { State as HighlightsState } from './Highlights';
import projectStats, { State as ProjectStatsState } from './ProjectStats';
import reviewLifecycleDuration, {
  State as ReviewLifecycleDurationState,
} from './ReviewLifecycleDuration';
import organizationBreakdown, {
  State as OrganizationBreakdownState,
} from './OrganizationBreakdown';
import pullRequestContribution, {
  State as PullRequestContributionState,
} from './PullRequestContribution';
import currentOrganizationUUID, {
  State as CurrentOrganizationUUIDState,
} from './CurrentOrganizationUUID';

export default combineReducers<DashboardState>({
  currentOrganizationUUID,
  benchmarkStandings,
  biggestChanges,
  contributionVolume,
  highlights,
  projectStats,
  reviewLifecycleDuration,
  organizationBreakdown,
  pullRequestContribution,
});

export interface DashboardState {
  currentOrganizationUUID: CurrentOrganizationUUIDState;
  benchmarkStandings: BenchmarkStandingsState;
  biggestChanges: BiggestChangesState;
  contributionVolume: ContributionVolumeState;
  highlights: HighlightsState;
  projectStats: ProjectStatsState;
  reviewLifecycleDuration: ReviewLifecycleDurationState;
  organizationBreakdown: OrganizationBreakdownState;
  pullRequestContribution: PullRequestContributionState;
}
